import { Result } from 'domain/types';
import ReadPresetField from 'use-case/presets/fields/read/readPresetField';
import ReadPresetFieldCriteria from 'use-case/presets/fields/read/readPresetFieldCriteria';
import PresetField from 'domain/entity/preset/field/presetField';

export type PresetFieldResult = Result<PresetField>;
export type ReadFieldValues = (criteria: ReadPresetFieldCriteria) => Promise<PresetFieldResult>;

export default (readPresetField: ReadPresetField): ReadFieldValues => (criteria: ReadPresetFieldCriteria): Promise<PresetFieldResult> =>
    readPresetField(criteria);
